export class BluechatNoteModalDelivery {
  public deliveryNumber: string;
  public carrierName: string;
  public carrierBlueyonderCode: string;
  public carrierBluechatCode: string;
  public carrierHasBluechatEnabled: boolean;
  public carrierExistsOnCmaWeb: boolean;
}
